import { useSmartMutation } from "@shared/api/queries/hooks";
import { downloadFile, openPdfInNewTab } from "@shared/utils/utils";
import { downloadBillTemplate } from "./api";

export const useDownloadBill = () => {
  return useSmartMutation(
    async ({
      billId,
      filename = "template.pdf",
    }: {
      billId: string;
      filename?: string;
    }) => {
      const blob = await downloadBillTemplate(billId);
      downloadFile(blob, filename);
      return blob;
    }
  );
};

export const useViewBill = () => {
  return useSmartMutation(async (billId: string) => {
    const blob = await downloadBillTemplate(billId);
    openPdfInNewTab(blob);
    return blob;
  });
};
